import React from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import CalloutScrollButton from '@Component/CalloutScrollButton';

const isWindowContext = typeof window !== 'undefined';
const isDocument = typeof document !== 'undefined';
const doScroll = (id) => {
  var currentDiv = document.getElementById(id);
  var nextDiv = currentDiv.nextElementSibling;
  window.scroll(0, nextDiv.offsetTop);
};

const CalloutWithScrollData = (props) => (
  <>
    <CalloutScrollButton
      id={`${props.rendering?.uid}`}
      title={<Text field={props.fields?.callouttitle} />}
      body={<RichText field={props.fields?.bodycopy} />}
      handleClick={() => doScroll(props.rendering?.uid)}
    />
  </>
);
export default CalloutWithScrollData;
